import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import useIsMobile from '../../hooks/useIsMobile';
import { DEFAULT_ICON_CLASS_NAME } from '../../theme/constants/icon';

const PendingDocumentsDialogFooter = ({ executiveAssigned }) => {
  const isMobile = useIsMobile('tablet');

  if (!executiveAssigned) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="flex-start">
      <Box sx={{ width: '50%' }}>
        <Typography variant={isMobile ? 'small_1' : 'medium_1'} color="gray.A500" fontWeight="500">
          Para mayor información, comunícate con tu ejecutivo
        </Typography>
      </Box>
      <Box
        sx={{ width: '50%' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Stack direction="row" alignItems="flex-start" spacing={2}>
          {!isMobile && (
            <Avatar sx={{ width: 45, height: 45 }}>
              <Typography variant="subtitle2">E</Typography>
            </Avatar>
          )}
          <Stack spacing={0.3}>
            <Typography variant={isMobile ? 'small_2' : 'medium_2'} color="gray.A800" fontWeight="500">
              {executiveAssigned.completeName}
            </Typography>
            <Stack direction="row" alignItems="center" spacing={0.3}>
              <WhatsAppIcon sx={{ width: 15, height: 15, color: '#25d366' }} />
              <Typography variant={isMobile ? 'small_1' : 'medium_1'} color="gray.A500" fontWeight="500">
                {executiveAssigned.phoneNumber?.replace(
                  /(\+\d{2})(\d)(\d{4})(\d{4})/,
                  '$1 $2 $3 $4',
                ) ?? null}
              </Typography>
            </Stack>
            <Stack direction="row" alignItems="center" spacing={0.3}>
              <EmailIcon className={DEFAULT_ICON_CLASS_NAME} sx={{ width: 15, height: 15 }} />
              <Typography variant={isMobile ? 'small_1' : 'medium_1'} color="gray.A500" fontWeight="500">
                {executiveAssigned.email}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Stack>
  );
};

PendingDocumentsDialogFooter.propTypes = {
  executiveAssigned: PropTypes.shape({
    id: PropTypes.string.isRequired,
    completeName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    phoneNumber: PropTypes.string.isRequired,
  }),
};

PendingDocumentsDialogFooter.defaultProps = {
  executiveAssigned: null,
};

export default PendingDocumentsDialogFooter;
